/*eslint-disable */
import React, { FC } from "react";
import MapSwitcher from "Components/MapSwitcher";
import { setCurrentView } from "Containers/MapSwitcher/mapSwitcher.Actions";
import { useSelector, useDispatch } from "react-redux";

interface Props {
  searchbarOption: string;
}

const MapSwitcherContainer: FC<Props> = ({ searchbarOption }: Props) => {
  const Dispatch = useDispatch();
  const currentView = useSelector(
    (store: any) => store.mapSwitcher.currentView
  );

  const changeView = (view: string) => {
    Dispatch(setCurrentView(view, true));
  };

  const handleKeyDown = (event: React.KeyboardEvent, view: string) => {
    if (event.key === "Enter") {
      changeView(view);
    }
  }

  return (
    <MapSwitcher
      currentView={currentView}
      changeView={changeView}
      searchbarOption={searchbarOption}
      handleKeyDown={handleKeyDown}
    />
  );
};
export default MapSwitcherContainer;
try {
    // @ts-ignore
    MapSwitcher.displayName = "MapSwitcher";
    // @ts-ignore
    MapSwitcher.__docgenInfo = { "description": "", "displayName": "MapSwitcher", "props": { "searchbarOption": { "defaultValue": null, "description": "", "name": "searchbarOption", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/MapSwitcher/MapSwitcher.tsx#MapSwitcher"] = { docgenInfo: MapSwitcher.__docgenInfo, name: "MapSwitcher", path: "src/shared/containers/MapSwitcher/MapSwitcher.tsx#MapSwitcher" };
}
catch (__react_docgen_typescript_loader_error) { }